module.exports = __webpack_public_path__ + "static/H-20a791a251839d64ac2ee98c75e052d9.png";